export const meta: BlockMeta = {
  title: "Featured Film",
  tags: ["subpage"],
  flags: {
    fullWidth: true,
  },
}

import { Themed } from "@components/atoms/Themed"
import { ParallaxCarousel } from "@components/media/ParallaxCarousel"
import { PlayTrailerButton } from "@components/media/TrailerOverlay"
import { Button } from "@components/ui/Button"
import { IconPlay } from "@components/ui/Icon"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/featured-film", (props) => {
  const image = props.film?.media?.thumb

  return (
    <Themed
      theme={props.theme!}
      type="bg"
      className="w-full my-10 flex flex-col-reverse md:flex-row md:pl-7 gap-4 md:gap-7 pl-4 pr-4 py-4 justify-between relative"
    >
      <div className="flex flex-col justify-between items-start w-full self-stretch relative pr-8">
        <div className="flex flex-col gap-4 pt-7">
          <EditableText
            store="subtitle"
            as="p"
            className="type-label-s uppercase"
            placeholder="Featured Film"
            defaultValue="Featured Film"
            plainText
          />
          <div className="flex flex-col type-title-xl my-3">{props.film?.title}</div>
          <div
            className="flex gap-3 justify-start items-center mb-4 [&_p]:!type-body-m"
            dangerouslySetInnerHTML={{ __html: props.film?.excerpt || "" }}
          />
        </div>
        <div className="flex gap-4 pb-6 md:pb-4 mt-4 md:mt-0">
          <Button href={props.film?.uri} className="w-fit">
            Book Tickets
          </Button>
          {props.film?.eventInfo?.trailer && (
            <PlayTrailerButton videoId={props.film?.eventInfo?.trailer}>
              <Button
                variant="outline"
                className="w-fit border-[2px] bg-transparent pl-3"
                leftIcon={<IconPlay className="!w-[1.25em] !h-[1.25em]" />}
              >
                Trailer
              </Button>
            </PlayTrailerButton>
          )}
        </div>
      </div>
      <div className="w-full md:w-[60%] h-blockFeaturedLinksH shrink-0 flex gap-4 flex-nowrap justify-center items-center overflow-hidden relative">
        {image && (
          <ParallaxCarousel
            className="h-full"
            images={[image, image, image]}
            startIndex={1}
            inactiveWidth={0.25}
            activeWidth={1.3}
            useCurrentOffset={false}
            controls={false}
            align="center"
          />
        )}
      </div>
    </Themed>
  )
})
